'use client';

import { c as _c } from "react/compiler-runtime";
import { TileCard } from './TileCard';
import { TileVideo } from './ui/tile-video';
import copy from '@/app/museum/_content/site-copy.json';
export default function MuseumTile(t0) {
  const $ = _c(5);
  const {
    className,
    onClick,
    description
  } = t0;
  const t1 = description ?? copy.site.name;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TileVideo src="/images/craft/museum-optimized.mp4" posterSrc="/images/craft/museum-poster.jpg" title={copy.site.craftTile.title} className="size-full object-cover transition-transform group-hover:scale-105" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className || $[2] !== onClick || $[3] !== t1) {
    t3 = <TileCard href="/museum" title={copy.site.craftTile.title} description={t1} className={className} onClick={onClick}>{t2}</TileCard>;
    $[1] = className;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}